import selectors from './selectors';
import itemTemplate from './itemTemplate';

const handleSearchSubmit = (event) => {
    event.preventDefault();
    const { cart, search, icons } = selectors;
    const { getResourcesEndpoint } = victaulicResources;

    const term = $(search.input).val();
    const button = $(search.form).find('.mdi');


    if (!term) {
        return false;
    }

    // Toggle the search icon into spining loading.
    button.toggleClass(icons.loading);

    $.ajax({
        url: getResourcesEndpoint + term,
        success(resources) {
            const dropdown = $(search.dropdown.id);

            // Let's make the template.
            const items = resources.map((resource) => itemTemplate(resource));
            const view = $('<div></div>').addClass(search.resources.wrapper).html(items);

            // Clean the last results.
            dropdown.empty();
            // Append the search results.
            dropdown.append(view);
            // Open the dropdown.
            dropdown.addClass('open');
            // Toggle the loading icon into search.
            button.toggleClass(icons.loading);
        },
        error(xhr) {
            const error = JSON.parse(xhr.responseText);
            const dropdown = $(search.dropdown.id);
            const message = error.message || 'Something is wrong with the response message.';
            const el = $('<div></div>')
                .addClass(cart.error.slug)
                .text(message);

            // Clean the last results.
            dropdown.empty();
            dropdown.append(el);
            // Open the dropdown.
            dropdown.addClass('open');
            // Toggle the loading icon into search.
            button.toggleClass(icons.mdiLoading);
        },
    });
    return true;
};

export default handleSearchSubmit;
